import { inEnum, isNumber, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking"

export enum MembershipTokenAudience {

    id_token = "id_token"
}



export interface TokenExtraData {
    membershipId: string
}


function isTokenExtraData(x: any): x is TokenExtraData {
    return isObject(x) &&
        ("membershipId" in x && isString(x.membershipId));
}

export interface MembershipIdTokenPayload {
    aud: MembershipTokenAudience.id_token,
    sub: string,
    nbf: number,
    extra_data: TokenExtraData,
    iss: string,
    name: string,
    exp: number,
    iat: number,
    nonce: string,
    jti: string,
    randomizer: string

    
}


function isMembershipIdTokenPayload(x: any): x is MembershipIdTokenPayload {

    return isObject(x) &&
        ("aud" in x && inEnum(x.aud, MembershipTokenAudience) && x.aud == MembershipTokenAudience.id_token) &&
        ("sub" in x && isString(x.sub)) &&
        ("nbf" in x && isNumber(x.nbf)) &&
        ("extra_data" in x && isTokenExtraData(x.extra_data)) &&
        ("iss" in x && isString(x.iss)) &&
        ("name" in x && isString(x.name)) &&
        ("exp" in x && isNumber(x.exp)) &&
        ("iat" in x && isNumber(x.iat)) &&
        ("nonce" in x && isString(x.nonce)) &&
        ("jti" in x && isString(x.jti)) &&
        ("randomizer" in x && isString(x.randomizer));
}


export enum MembershipIdTokenValidation {

    INVALID_DATA = "invalid_data",
    EXPIRED = "expired",
    NEARLY_EXPIRED = "nearly_expired",
    VALID = "valid"

}


export function extractTokenFromString(s: string): MembershipIdTokenPayload  {

    let returnData: MembershipIdTokenPayload = null;
    if(s && s !== '') {
        try {
            const raw =  JSON.parse(atob(s.split('.')[1]));
            if("extra_data" in raw && isString(raw.extra_data)) {
                const parsed_ed = JSON.parse(raw.extra_data);
                raw["extra_data"] = parsed_ed;
                if(isMembershipIdTokenPayload(raw)) {
                    returnData = raw;   
                } 
            }
        }catch(e) {
            console.error(e);
        }
    }
    return returnData;
}


export function validateMembershipIdToken(token: MembershipIdTokenPayload): MembershipIdTokenValidation {

    const currentEpoch = Math.floor(new Date().getTime() / 1000);
    
    if(token && token.iss == "Ciaopeople") {
        if(token.iat <= currentEpoch &&
            token.nbf <= currentEpoch &&
                token.exp > currentEpoch) {

            const nearlyExpiringThreshold = Math.floor((token.exp - token.iat) * 0.15);        
            if(token.exp - currentEpoch > nearlyExpiringThreshold) return MembershipIdTokenValidation.VALID;
            else return MembershipIdTokenValidation.NEARLY_EXPIRED;
        }
        else return MembershipIdTokenValidation.EXPIRED;
    }
    else return MembershipIdTokenValidation.INVALID_DATA;
    
    
}